<template>
  <aside 
    class="aside wysiwyg"
    :class="`aside--${position}`"
    v-html="text"></aside>
</template>

<script>
export default {
  name: 'AsideBlock',
  props: {
    text: {
      type: String,
      default: null
    },
    position: {
      type: String,
      default: 'left'
    }
  }
}
</script>

<style lang="scss">
.aside {
  width:50%;
  &--right {
    margin: 0 0 0 50% !important;;
  }

  p {
    font-size: inherit;
  }

  @include mobile {
    width:80%;

    &--right {
    margin: 0 0 0 20% !important;;
  }
  }
}
</style>